export default __webpack_public_path__ + "static/kb_en-1b831346a3dd61c9d3e0158e066f6a10.jpg";